import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MpupContactInfoComponent } from './components/mpup-contact-info/mpup-contact-info.component'
import { MbI18nModule } from '../../translations/mb-i18n.module'
import { MpupSearchComponent } from './components/mpup-search/mpup-search.component'
import { ReactiveFormsModule } from '@angular/forms'
import { MpupFridgeSelectComponent } from './components/mpup-fridge-select/mpup-fridge-select.component'
import { MpupNavigationComponent } from './components/mpup-navigation/mpup-navigation.component'
import { MpupHeaderComponent } from './components/mpup-header/mpup-header.component'
import { MpupFilterComponent } from './components/mpup-filter/mpup-filter.component'
import { RouterLink } from '@angular/router'
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'

@NgModule({
  declarations: [
    MpupContactInfoComponent,
    MpupSearchComponent,
    MpupFridgeSelectComponent,
    MpupNavigationComponent,
    MpupHeaderComponent,
    MpupFilterComponent
  ],
  exports: [
    MpupContactInfoComponent,
    MpupSearchComponent,
    MpupFridgeSelectComponent,
    MpupNavigationComponent,
    MpupHeaderComponent,
    MpupFilterComponent
  ],
    imports: [
        CommonModule,
        MbI18nModule,
        ReactiveFormsModule,
        RouterLink,
        NgbTooltipModule,
    ]
})
export class MpupSharedModule { }
